import { cn } from "@repo/ui/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse delay-1000 bg-secondary-gray2 dark:bg-[#333333]",
        className,
      )}
      style={{ animationDirection: "reverse", willChange: "opacity" }}
      {...props}
    />
  );
}

export { Skeleton };
